/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Label type enumeration.
 */
export type LabelKind = typeof LabelKind[keyof typeof LabelKind];


export const LabelKind = {
  premiere: 'premiere',
  fresh: 'fresh',
  abandoned: 'abandoned',
  exclusive: 'exclusive',
  top: 'top',
} as const;
